import React from 'react'

const handleClick = (e) => {
    e.stopPropagation();
}

function ChatModal (props) {
    return (
        <div className="chat-modal" onClick={handleClick}>
            <div className="chat-modal__option" onClick={() => {
                props.sendMessage({type: "text", text: "領取訊號", data: "get"});
                props.setShowChatModal(false);
            }}>領取訊號</div>
            <div className="chat-modal__option" onClick={() => {
                props.sendMessage({type: "text", text: "創造訊號", data: "create"});
                props.setShowChatModal(false);
            }}>創造訊號</div>
        </div>
    )
}

export default ChatModal;